<template>
  <div class="card mb-3">
    <div class="card-body">

      <template v-if="options.length">

        <template v-if="mode === 'list'">

          <div class="row">
            <div class="col-sm-6">
              <div class="text-muted">{{ title }}</div>
            </div>
            <div v-if="unselected.length" class="col-sm-6 text-right mb-2">
              <button class="btn btn-outline-secondary btn-sm" @click="mode = 'add'"><i class="fa fa-fw fa-plus"></i> Add an item</button>
            </div>
          </div>

          <table class="table table-striped table-hover mb-1">
            <tbody>
              <tr v-for="(option, num) in limitedSelected">
                <td v-if="option.id !== ''">
                  {{ num + 1 }}
                </td>
                <td v-html="option.label">
                </td>
                <td class="text-right">
                  <button v-if="option.id !== ''" class="btn btn-sm btn-outline-secondary py-0" @click="remove(option.id)"><i class="fa fa-close"></i></button>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="oversizeCount > 0" class="text-right">
            <button v-if="!expanded" class="btn btn-outline-secondary btn-sm" @click="expand"><i class="fa fa-caret-down"></i> Expand <strong>{{ oversizeCount }}</strong> more item(s)</button>
            <button v-else class="btn btn-outline-secondary btn-sm" @click="collapse"><i class="fa fa-caret-up"></i> Collapse</button>
          </div>

        </template>

        <template v-if="mode === 'add'">

          <div class="text-right mb-2">
            <button class="btn btn-outline-secondary btn-sm" @click="backToList"><i class="fa fa-fw fa-arrow-left"></i> Back to list</button>
          </div>

          <table class="table table-striped table-hover mb-1">
            <tbody>
            <tr v-for="option in unselected">
              <td v-html="option.label">
              </td>
              <td class="text-right">
                <button class="btn btn-sm btn-outline-secondary py-0" @click="add(option.id)"><i class="fa fa-plus"></i></button>
              </td>
            </tr>
            </tbody>
          </table>

        </template>

      </template>

      <template v-else>
        <template v-if="isLoading">
          <i class="fa fa-spinner fa-spin"></i> Loading items...
        </template>
        <template v-else>
          No options found.
        </template>
      </template>

    </div>
  </div>
</template>

<script>
export default {

  emits: ['update:modelValue'],

  props: {
    // Full list of available items. Every item should be an object containing at least "id" and "label" properties.
    options: {
      type: Array,
      default: function () { return [] }
    },

    // Component value. A list of selected ids.
    modelValue: {
      type: Array,
      default: function () { return [] }
    },

    // List size limit. If selected items exceed this limit, expand/collapse buttons will appear.
    listSize: {
      type: Number,
      default: 10,
    },

    // Title.
    title: {
      type: String,
      default: "Select items..."
    },

    // Loading indicator.
    isLoading: false,
  },

  data () {
    return {

      // Local list size (for expand/collapse).
      localListSize: this.listSize,

      // Is list expanded.
      expanded: false,

      // View modes: "list", "add".
      mode: 'list',

    }
  },

  computed: {

    valueModel: {
      get () { return this.modelValue },
      set (value) { this.$emit('update:modelValue', value) },
    },

    // All options.
    all() {
      return this.options.map(option => {
        option.id = String(option.id);
        return option;
      });
    },

    // List of selected options.
    selected() {
      let selected = this.all.filter(option => this.ids.indexOf(String(option.id)) >= 0);
      if (selected.length === 0) selected = [{'id': '', 'label': '- no selected items -'}];
      return selected;
    },

    // List of selected options in list size limit.
    limitedSelected() {
      return this.selected.slice(0, this.localListSize);
    },

    // Dhe difference between selected items count and list size limit.
    oversizeCount() {
      return this.selected.length - this.listSize;
    },

    // List of unselected options.
    unselected() {
      return this.all.filter(option => this.ids.indexOf(String(option.id)) === -1);
    },

    // List of selected string ids.
    ids() {
      return this.valueModel.map(id => String(id));
    },
  },

  methods: {

    /**
     * Add id to list.
     *
     * @param idToAdd
     */
    add(idToAdd) {
      this.valueModel.push(String(idToAdd));
      if (this.unselected.length === 0) this.backToList();
    },

    /**
     * Remove id from list.
     *
     * @param idToRemove
     */
    remove(idToRemove) {
      this.valueModel = this.valueModel.filter(id => String(id) !== idToRemove);
    },

    /**
     * Expand selected item list.
     */
    expand() {
      this.localListSize = this.selected.length;
      this.expanded = true;
    },

    /**
     * Collapse selected item list.
     */
    collapse() {
      this.localListSize = this.listSize;
      this.expanded = false;
    },

    /**
     * Go back to list mode.
     */
    backToList() {
      this.mode = 'list';
      if (this.expanded) this.expand(); else this.collapse();
    },

  },
}
</script>
